import { cm } from '~/utils/utils'

export interface CampaignContextBlockProps {
  text?: BlockText | null
  fields?: {
    align?: 'center' | 'left' | 'right'
  }
}

export function CampaignContextBlock({ text, fields }: CampaignContextBlockProps) {
  const value = text?.text || ''
  const align = fields?.align || 'left'
  return <div className={cm('mx-[40px] mb-5', `text-${align}`)}>{value}</div>
}
